import { DOCUMENT } from '@angular/common';
import { inject, Injectable } from '@angular/core';

/** How often a tab left open asks whether a newer build was deployed. */
export const CHECK_EVERY = 5 * 60_000;

/** A tab keeps running the bundle it loaded, however many deploys later. */
@Injectable({ providedIn: 'root' })
export class BuildWatcher {

  private document = inject(DOCUMENT);

  /** Calls `deployed` once, when `page` starts a different main bundle than this tab runs. */
  watch(page: string, deployed: () => void): void {
    const running = this.document.querySelector('script[src*="main-"]')?.getAttribute('src');
    if (!running) {
      return;
    }
    const timer = setInterval(async () => {
      if (await this.replaced(page, running)) {
        clearInterval(timer);
        deployed();
      }
    }, CHECK_EVERY);
  }

  private async replaced(page: string, running: string): Promise<boolean> {
    try {
      const response = await fetch(page, { cache: 'no-store' });
      const html = response.ok ? await response.text() : '';
      // A missing page or a login page has no main bundle, and must not count as a new build
      return /<script[^>]+src="[^"]*main-/.test(html) && !html.includes(running);
    } catch {
      // Offline: the next check tries again
      return false;
    }
  }

}
